import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params, RoutesRecognized } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as globalConst from './../../../../constants';

import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/filter';

// Services
import { OrderDetailService } from '../../service/order-detail/order-detail.service';
import { DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from "../../../shared/alert/alert.component";

@Component({
	selector: 'app-order-detail',
	templateUrl: './order-detail.component.html',
	providers: [
		OrderDetailService,
		HttpModule
	]
})
export class OrderDetailComponent implements OnInit {

	Divisao: string;
	ItemOrdemVendaItem: string;
	OrdemVendaNumero: string;
	previousPage: string;

	private token;
	private sub: any
	public orderOwner: string = "";
	public permissoes: any[] = [];


	public order: any[] = [];
	private item;
	public division: any[] = [];
	public client: any[] = [];

	public logs: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "DataInicial";
	public sort: string = "desc";
	currentPage: number = 0;

	constructor(fb: FormBuilder, private orderDetailService: OrderDetailService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService, private dialogService: DialogService) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {

		this.previousPage = localStorage.getItem('yara.previousPage');
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		this.sub = this.route.params.subscribe(params => {
			this.Divisao = params['Divisao'];
			this.ItemOrdemVendaItem = params['ItemOrdemVendaItem'];
			this.OrdemVendaNumero = params['OrdemVendaNumero'];
		});

		this.getOrderDetail();
		this.getLogs(this.currentPage, false);
		//this.getAccountDivistionDetails(this.Divisao, this.ItemOrdemVendaItem, this.OrdemVendaNumero);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getLogs(this.currentPage, false);
	}

	getOrderDetail() {
		this.orderDetailService.getOrderDetail(this.OrdemVendaNumero).subscribe(result => {
			if (result.Success) {
				this.order = result.Result;
				const tempItem = this.order['Itens'].filter(item => item.Item == this.ItemOrdemVendaItem);
				this.item = tempItem[0];
				const tempDivisao = this.order['DivisaoRemessas'].filter(item => item.ItemOrdemVendaItem == this.ItemOrdemVendaItem && item.Divisao == this.Divisao);
				this.division = tempDivisao[0];
				console.log("Division",this.division);
				console.log("ITEM",this.item);
				console.log("this.order", this.order);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	getLogs(page, isSearch) {
		if (isSearch) {
			this.orderby = "DataInicial";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.orderDetailService.getLogs(this.token, this.Divisao, this.ItemOrdemVendaItem, this.OrdemVendaNumero, this.sort, this.orderby, page).subscribe(result => {
			if (result.Success) {
				this.logs = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	getLogFlowDetails(divisao, item, numero, idSolicitante) {
		this.orderDetailService.getLogFlowDetails(this.token, divisao, item, numero, idSolicitante).subscribe(result => {
			if (result.Success) {
				this.showLogFlowDetail(result.Result);
				
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	showLogFlowDetail(obj){
		this.dialogService.addDialog(AlertComponent, {title:'Histórico do Fluxo', obj: obj}, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
	}

	// getAccountDivistionDetails(divisao, item, numero) {
	// 	this.orderDetailService.getAccountDivistionDetails(this.token, divisao, item, numero).subscribe(result => {
	// 		if (result.Success) {
	// 			this.division = result.Result;
	// 			console.log("this.division", this.division);
	// 		} else {
	// 			this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
	// 		}
	// 		this.getLogs(0, false);
	// 	}, error => {
	// 		console.log(error);
	// 		this.getLogs(0, false);
	// 	});
	// }


	getAccountClientDetails(idAccountClient) {
		this.orderDetailService.getAccountClientDetails(this.token, idAccountClient).subscribe(result => {
			if (result.Success) {
				this.client = result.Result;
				console.log(this.client);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
			//this.getAccountDivistionDetails(this.Divisao, this.ItemOrdemVendaItem, this.OrdemVendaNumero);
		}, error => {
			console.log(error);
			
		});
	}

	bloquearOrder() {
		
		var data = [{
			SolicitanteFluxoID: '',
			FluxoLimiteCreditoID: '',
			Divisao: this.Divisao,
			ItemOrdemVenda: this.ItemOrdemVendaItem,
			OrdemVendaNumero: this.OrdemVendaNumero,
			UsuarioID: '',
			Status: '',
			ID: ''
		}];

		this.orderDetailService.blockOrder(this.token, data).subscribe(result => {
			console.log("AH", result);
			if (result.Success) {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/cockpit');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	// solicitarLiberacaoOrder() {

	// 	var data = [{
	// 		Divisao: this.Divisao,
	// 		ItemOrdemVenda: this.ItemOrdemVendaItem,
	// 		OrdemVendaNumero: this.OrdemVendaNumero,
	// 	}]

	// 	this.orderDetailService.releaseOrder(this.token, data).subscribe(result => {
	// 		if (result.Success) {
	// 			this.flashMessagesService.show(result.Errors, { cssClass: 'alert-success', timeout: 6000 });
	// 		} else {
	// 			this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
	// 		}
	// 		this.router.navigateByUrl('/ordem');
	// 	}, error => {
	// 		console.log(error);
			
	// 	});
	// }


	// aprovarOrder() {

	// 	var data = {
	// 		SolicitanteFluxoID: '',
	// 		FluxoLimiteCreditoID: '',
	// 		Divisao: this.Divisao,
	// 		ItemOrdemVenda: this.ItemOrdemVendaItem,
	// 		OrdemVendaNumero: this.OrdemVendaNumero,
	// 		UsuarioID: '',
	// 		Status: '',
	// 		ID: ''
	// 	}

	// 	this.orderDetailService.approveOrder(this.token, data).subscribe(result => {
	// 		if (result.Success) {
	// 			this.flashMessagesService.show(result.Errors, { cssClass: 'alert-success', timeout: 6000 });
	// 		} else {
	// 			this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
	// 		}
	// 		this.router.navigateByUrl('/cockpit');
	// 	}, error => {
	// 		console.log(error);
			
	// 	});
	// }

	paginar($event: any) {
		this.currentPage = $event;
		this.getLogs($event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/order/component/order-detail/order-detail.component.ts